// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"1e78668e","156":"c599f604","224":"54783fe8","591":"6e8574e4","682":"8be8fa34","713":"02b2e722","825":"6df95f7c","828":"b0126fee"}[chunkId] + ".chunk.js";
};